import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appMobileNumber]'
})
export class MobileNumberDirective {
  inputElement: HTMLElement;
  constructor(private el: ElementRef) {
    this.inputElement = this.el.nativeElement
  }

  @HostListener('keyup', ['$event']) onKeyDown(event) {
    let e: any = <KeyboardEvent>event;
    let str: string = this.el.nativeElement.value;
    let firstletter: string = str.substr(0, 1);

    if (firstletter != "5") {
      this.el.nativeElement.value = "";
      //e.preventDefault();
    }


  }

}
